import { HeroSection } from "@/components/design-system/HeroSection/HeroSection";
import { URLS } from "@/data/constants";
import { trackCalendlyClick } from "@/utils/analytics";
import React from "react";

export const EmployerHeroSection: React.FC = () => {
  const handleCalendlyClick = () => {
    trackCalendlyClick("emp_hero");
    window.open(URLS.CALENDLY, "_blank");
  };

  return (
    <HeroSection
      headline="Financial stress is costing more than you think."
      description="Bravo gives every employee a personal financial guide that helps reduce stress, improve wellbeing, and support workplace performance."
      primaryCta={{ label: "Book a demo", onClick: handleCalendlyClick }}
      backgroundImage="/emp-hero.jpg"
      imageClassName="absolute top-0 right-0 h-full w-[65%] object-cover"
    />
  );
};
